/**
 * Contact API Service
 * 
 * All contact-related API endpoints following the API v2.0 specification.
 */

import { get, post } from '../../utils/httpClient';
import logger from '../../utils/logger';

/**
 * Submit a contact form
 */
export const submitContactForm = async (formData) => {
  try {
    const { name, email, phone, message } = formData;

    // Validate required fields
    if (!name || !email || !phone || !message) {
      throw new Error('All fields are required');
    }

    // The API expects data directly (no wrapper)
    const response = await post('/contact/send', {
      name: name.trim(),
      email: email.trim(),
      phone: phone.trim(),
      message: message.trim(),
    });

    return response.data;
  } catch (error) {
    logger.error('Failed to submit contact form', error, { formData });
    throw error;
  }
};

/**
 * Get all contact form submissions (admin)
 */
export const fetchAllContactSubmissions = async () => {
  try {
    const response = await get('/contact/list');
    return response.data || [];
  } catch (error) {
    logger.error('Failed to fetch contact submissions', error);
    throw error;
  }
};

